<template>
  <v-dialog :value="value" :max-width="maxWidth" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Cancelar</v-btn>
        <v-btn color="primary" :loading="loading" @click="$emit('confirm')">
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, required: true },
    loading: { type: Boolean, default: false },
    confirmLabel: { type: String, default: "Salvar" },
    maxWidth: { type: String, default: "500px" },
  },
};
</script>